import { Link } from "react-router-dom";

import alexandreNadeau from "../assets/alexandre-nadeau.jpeg";
import laireineF from "../assets/laireine-frechette.png";
import lucienT from "../assets/lucien-tchiendje.png";

const team = [
  {
    img: alexandreNadeau,
    alt: "Alexandre Nadeau, fondateur et conseiller en architecture technologique",
    eyebrow: "Fondateur",
    name: "Alexandre Nadeau",
    title: "Conseiller en architecture technologique",
    bio: [
      "Fort d'une décennie d'expérience chez Desjardins, où il a affiné ses compétences en tant qu'analyste en sécurité informatique et Scrum Master pour diverses équipes de projets dans le secteur des assurances, Alexandre s'est forgé une réputation solide dans l'industrie. En 2021, il a lancé CPUcompliqué inc., une initiative personnelle qui reflète son esprit d'entrepreneur et sa passion pour l'innovation technologique.",
      "Son parcours l'a également conduit dans le secteur médical, où il applique ses compétences en technologie et en gestion de projets pour améliorer les systèmes et les processus dans ce domaine vital. Avec une expérience riche et diversifiée, renforcée par une formation continue dans les domaines les plus pointus de la technologie, Alexandre est prêt à être votre meilleur allié — pour transformer vos défis informatiques en succès tangibles.",
    ],
  },
  {
    img: laireineF,
    alt: "Lauriane Fréchette, directrice adjointe chez CPUc Solutions Technologiques",
    eyebrow: "Directrice adjointe",
    name: "Lauriane Fréchette",
    title: "Directrice adjointe",
    bio: [
      "Lauriane apporte un soutien précieux à la direction et aux opérations administratives de l'entreprise. À temps partiel, elle contribue au suivi de différents dossiers, à la coordination de certaines activités et à l'amélioration continue de nos processus interne.",
      "Organisée, minutieuse et toujours soucieuse du travail bien fait, elle joue un rôle important en arrière-plan afin de soutenir l'équipe et d'assurer le bon fonctionnement de l'entreprise.",
    ],
  },
  {
    img: lucienT,
    alt: "Lucien Tchiendje, technicien spécialisé en informatique et développeur chez CPUc Solutions Technologiques",
    eyebrow: "Technicien spécialisé",
    name: "Lucien Tchiendje",
    title: "Technicien spécialisé en informatique & développeur",
    bio: [
      "Lucien est la force technique derrière nos déploiements les plus complexes. Technicien spécialisé et développeur, il maîtrise aussi bien l'infrastructure réseau et la téléphonie IP que le développement d'outils sur mesure pour nos clients.",
      "Sa polyvalence lui permet d'intervenir autant sur une configuration de centrale téléphonique que sur l'automatisation d'un processus métier — toujours avec précision et un souci du détail qui fait la différence sur le terrain.",
    ],
  },
];

export default function APropos() {
  return (
    <section className="section">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <span className="eyebrow">Notre équipe</span>
          <h1 className="fw-900 mt-3 display-5">Les personnes derrière CPUc</h1>
          <p
            className="lead text-secondary mt-3 mx-auto"
            style={{ maxWidth: "640px" }}
          >
            Une équipe à taille humaine, passionnée par la technologie et
            engagée à offrir un service de proximité à chaque client.
          </p>
        </div>

        {team.map((member, i) => (
          <div
            key={member.name}
            className={`row align-items-center gy-5 mb-5 pb-5 ${i < team.length - 1 ? "border-bottom" : ""}`}
            data-aos="fade-up"
          >
            <div className={`col-lg-4 ${i % 2 !== 0 ? "order-lg-2" : ""}`}>
              <div className="section-img">
                <img src={member.img} alt={member.alt} />
              </div>
            </div>
            <div
              className={`col-lg-7 ${i % 2 !== 0 ? "order-lg-1" : "offset-lg-1"}`}
            >
              <span className="eyebrow">{member.eyebrow}</span>
              <h2 className="fw-900 mt-2 display-6">{member.name}</h2>
              <p className="fw-bold text-secondary mb-3">{member.title}</p>
              {member.bio.map((p, j) => (
                <p className="text-secondary" key={j}>
                  {p}
                </p>
              ))}
            </div>
          </div>
        ))}

        <div className="text-center mt-2" data-aos="fade-up">
          <Link
            to="/contact"
            className="btn btn-brand btn-lg rounded-pill px-5"
          >
            Planifier un échange avec notre équipe
          </Link>
        </div>
      </div>
    </section>
  );
}
